import React, { Component } from 'react';

import Configs from 'Configuration';
import FhtFetchUrl from 'Utils/FhtFetchUrl.jsx';

import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Paper,
  Snackbar,
  TextField,
  Typography,
} from '@material-ui/core';

import SnackbarContentWrapper from 'components/SnackbarContentWrapper';

class WebProjectAppointmentEligibility extends Component {
  constructor(props) {
    super(props);

    this.state = {
      appointmentQueryInterval: ""
    };

    this.getSmsSettings();
  }

  render() {
    return (
      <Box maxWidth={800} margin="auto">
        {this.renderSnackbar()}
        <Typography variant="h3" gutterBottom>Appointment Eligibility & Intervals</Typography>
        <Grid container spacing={3}>
          <Grid item sm={12}>
            <Paper>
              <Box sx={{ padding: 12 }}>
                <Typography variant="h6" gutterBottom>Appointment Query Interval</Typography>
                <Typography variant="subtitle1">How often WEB queries the appointment booking table</Typography>
                <TextField
                  fullWidth
                  type="number"
                  variant="outlined"
                  label="Query Interval"
                  value={this.state.appointmentQueryInterval}
                  onChange={(e) => this.setState({ appointmentQueryInterval: e.target.value })}
                  helperText="Minutes between queries"
                  margin="normal"
                />
              </Box>
            </Paper>
          </Grid>
          <Grid container spacing={1} justifyContent="center">
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                onClick={() => this.setSmsSettings()}>
                {this.state.settingsIsSaving ? <CircularProgress color="inherit" size={20} /> : "Save"}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    );
  }

  renderSnackbar() {
    return (
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={this.state.openSnackbar}
        autoHideDuration={4000}
        onClose={() => this.setState({ openSnackbar: false })}
      >
        <SnackbarContentWrapper
          onClose={() => this.setState({ openSnackbar: false })}
          variant={this.state.snackbarVariant}
          message={this.state.snackbarMessage}
        />
      </Snackbar>
    );
  }

  async getSmsSettings() {
    try {
      const api = FhtFetchUrl(Configs.getSmsSettings);
      const response = await api.post(["AppointmentScanFrequencyMinutes"]);
      const appointmentQueryInterval = response["AppointmentScanFrequencyMinutes"];
      this.setState({
        appointmentQueryInterval
      });
    }
    catch (e) {
      this.setState({ snackbarMessage: "Could get SMS settings", snackbarVariant: "error", openSnackbar: true });
    }
  }

  async setSmsSettings() {
    try {
      const api = FhtFetchUrl(Configs.setSmsSettings);
      this.setState({ settingsIsSaving: true });
      await api.post({
        "AppointmentScanFrequencyMinutes": this.state.appointmentQueryInterval
      });

      this.setState({ snackbarMessage: "Settings saved successfully", snackbarVariant: "success", openSnackbar: true });
    }
    catch (e) {
      this.setState({ snackbarMessage: "Could not save SMS settings", snackbarVariant: "error", openSnackbar: true });
    }
    finally {
      this.setState({ settingsIsSaving: false });
    }
  }
}

export default WebProjectAppointmentEligibility;
